<div class="content">
  <mat-icon class="close-modal" (click)="closeModal()">close</mat-icon>
  <h2 class="title">Crear nuevo caso</h2>
  <!-- <mat-icon class="close-modal" (click)="closeModal()">close</mat-icon> -->

  <form [formGroup]="caseForm">
    <div class="row">
      <!-- Fechas -->
      <div class="col-3" *ngFor="let campo of ['fechaEvento']; let i = index">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ formatStepLabel(campo) | titlecase }}</mat-label>
          <input [formControlName]="campo" matInput type="date" />
        </mat-form-field>
      </div>
      <div class="row">
        <!-- Origen -->
        <div class="col-12">
          <p class="section">Origen</p>
        </div>
        <div class="col-3">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Origen</mat-label>
            <mat-select formControlName="origen">
              <mat-option value="">Seleccione</mat-option>
              <mat-option value="Área de Reclamos">Área de Reclamos</mat-option>
              <mat-option value="Oficinas Bancarias"
                >Oficinas Bancarias</mat-option
              >
              <mat-option value="Oficinas Bancarias"
                >Oficinas Bancarias</mat-option
              >
              <mat-option
                *ngIf="userService.currentUser.role.name === 'Soporte'"
                value="Soporte y reclamo"
                >Soporte y reclamo</mat-option
              >
              <mat-option value="Otras áreas administrativas del Banco"
                >Otras áreas administrativas del Banco</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Naturaleza -->

        <div class="col-3">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Naturaleza del caso</mat-label>
            <mat-select
              formControlName="naturaleza"
              (selectionChange)="actualizarValidacionOtros()"
            >
              <mat-option *ngFor="let n of naturalezaOptions" [value]="n">{{
                n
              }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field
            *ngIf="caseForm.value.naturaleza === 'Otros'"
            appearance="outline"
            class="full-width"
          >
            <input
              placeholder="Ingrese Naturaleza del caso"
              formControlName="naturalezaOtro"
              matInput
            />
          </mat-form-field>
        </div>

        <!-- Nombre completo -->
        <div class="col-3" formGroupName="elaboradoPor">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Nombre completo</mat-label>
            <input matInput formControlName="nombreCompleto" type="text" />
          </mat-form-field>
        </div>

        <!-- Cargo -->
        <div class="col-3" formGroupName="elaboradoPor">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Cargo</mat-label>
            <input matInput formControlName="cargo" type="text" />
          </mat-form-field>
        </div>
        <div class="col-12">
          <p class="section">Instrumento</p>
        </div>

        <!-- Monto afectado -->
        <div class="col-3" *ngIf="showAmountField">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Monto afectado</mat-label>
            <input
              Currency
              formControlName="montoAfectado"
              type="text"
              matInput
            />
          </mat-form-field>
        </div>

        <!-- Número de instrumento -->
        <div class="col-3" formGroupName="instrumento">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Número de instrumento</mat-label>
            <input matInput formControlName="numero" type="text" />
          </mat-form-field>
        </div>

        <!-- Datos del instrumento -->

        <div class="col-3" formGroupName="instrumento">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Datos del instrumento</mat-label>
            <input matInput formControlName="datosInstrumento" type="text" />
          </mat-form-field>
        </div>

        <!-- Referencia -->

        <div class="col-3" formGroupName="instrumento">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>referencia</mat-label>
            <input matInput formControlName="referencia" type="text" />
          </mat-form-field>
        </div>
        <!-- Víctima -->
        <div class="col-3" formGroupName="victima" *ngIf="showVictimFields">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Nombre completo</mat-label>
            <input formControlName="nombre" matInput />
          </mat-form-field>
        </div>

        <div class="col-3" formGroupName="victima" *ngIf="showVictimFields">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Cédula</mat-label>
            <input formControlName="cedula" matInput />
          </mat-form-field>
        </div>

        <div class="col-3" formGroupName="victima" *ngIf="showVictimFields">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Teléfono</mat-label>
            <input formControlName="telefono" matInput />
          </mat-form-field>
        </div>

        <div class="col-3" formGroupName="victima" *ngIf="showVictimFields">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Dirección</mat-label>
            <input formControlName="direccion" matInput />
          </mat-form-field>
        </div>
      </div>

      <!-- Resumen -->
      <div class="col-12">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Resumen del hecho</mat-label>
          <textarea formControlName="resumen" rows="4" matInput></textarea>
        </mat-form-field>
      </div>

      <!-- Recaudos -->
      <div class="col-12">
        <p class="section">Recaudos consignados</p>
        <button mat-button type="button" color="primary" (click)="addRecaudo()">
          + Añadir recaudo
        </button>

        <!-- SOLO renderiza si hay items -->
        <div class="row" *ngFor="let rec of recaudos.controls; let i = index">
          <div class="col-10">
            <div class="file-picker">
              <mat-form-field
                appearance="outline"
                class="w-100 mb-2"
                *ngIf="recaudos.at(i).value.editing"
              >
                <mat-label>Nombre del recaudo</mat-label>
                <input
                  matInput
                  [formControl]="recaudoFormControl(i)"
                  placeholder="Escribe el nombre aquí"
                />
                <button
                  mat-icon-button
                  matSuffix
                  (click)="toggleRecaudoMode(i)"
                  [disabled]="recaudos.at(i).value.recaudo?.length < 3"
                >
                  <mat-icon>done</mat-icon>
                </button>
              </mat-form-field>

              <div
                class="d-flex align-items-center mb-2"
                *ngIf="!recaudos.at(i).value.editing"
              >
                <h4 class="mb-0 me-2">
                  {{ recaudos.at(i).value.recaudo }}
                </h4>
                <button
                  mat-icon-button
                  color="primary"
                  (click)="toggleRecaudoMode(i)"
                >
                  <mat-icon>edit</mat-icon>
                </button>
              </div>

              <div>
                <input
                  type="file"
                  #recFile
                  (change)="onFileSelected($event, i, 'recaudos')"
                  hidden
                />
                <button
                  mat-stroked-button
                  type="button"
                  (click)="recFile.click()"
                >
                  Seleccionar archivo
                </button>
                <span class="file-name">{{
                  rec.value?.file?.name
                    ? rec.value?.file?.name
                    : "Ningún archivo seleccionado"
                }}</span>
              </div>
            </div>
          </div>
          <div class="col-1">
            <button mat-icon-button color="warn" (click)="removeRecaudo(i)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
        <!-- <ng-container *ngIf="recaudos.length > 0">
          <div class="row" *ngFor="let rec of recaudos.controls; let i = index">
            <div class="col-10">
              <div class="file-picker">
                <input
                  type="file"
                  #recFile
                  (change)="onFileSelected($event, i, 'recaudos')"
                  hidden
                />
                <button
                  mat-stroked-button
                  type="button"
                  (click)="recFile.click()"
                >
                  Seleccionar archivo
                </button>
                <span class="file-name">{{
                  rec.value?.name
                    ? rec.value?.name
                    : "Ningún archivo seleccionado"
                }}</span>
              </div>
            </div>
            <div class="col-1">
              <button mat-icon-button color="warn" (click)="removeRecaudo(i)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        </ng-container> -->
      </div>

      <!-- Recaudos pendientes -->
      <!-- <div class="col-6">
        <p class="section">Recaudos pendientes</p>

        <ng-container *ngIf="recaudos.length > 0">
          <div
            class="row"
            *ngFor="let item of recaudos.controls; let i = index"
          >
            <div class="col-10">
              <div class="d-flex align-items-center mb-2">
                <h4 class="mb-0 me-2">
                  {{ recaudos.at(i).value.recaudo }}
                </h4>

                <mat-icon *ngIf="!item.value.file" color="warn">
                  radio_button_unchecked
                </mat-icon>
                <mat-icon *ngIf="item.value.file" color="primary">
                  check_circle
                </mat-icon>
              </div>
            </div>
            <div class="col-1">
              <button mat-icon-button>
                <mat-icon *ngIf="!item.value.file" color="warn">
                  error_outline
                </mat-icon>
                <mat-icon *ngIf="item.value.file" color="primary">
                  check
                </mat-icon>
              </button>
            </div>
          </div>
        </ng-container>
      </div> -->

      <mat-checkbox formControlName="sinRecaudos" class="custom-checkbox">
        No hay recaudos que consignar
      </mat-checkbox>
      <!-- Gestión del caso -->

      <div class="col-12" *ngIf="caseManagement">
        <p class="section">Gestión del caso</p>
      </div>

      <div class="col-6" *ngIf="caseManagement">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Coordinador asignado</mat-label>
          <input formControlName="gestionCaso.coordinador" matInput />
        </mat-form-field>
      </div>

      <div class="col-6" *ngIf="caseManagement">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Especialista asignado</mat-label>
          <input formControlName="gestionCaso.especialista" matInput />
        </mat-form-field>
      </div>

      <!-- Botón -->
      <div class="col-12 text-center">
        <button
          mat-flat-button
          color="primary"
          (click)="submit()"
          [disabled]="caseForm.invalid"
        >
          {{ this.data.edit ? "Actualizar caso" : "Crear caso" }}
        </button>
      </div>
    </div>
  </form>
</div>
